// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"Preliminares__tabsContainer__c8pj2"};